<template>
  <div class="member-center ">
    <div class="bg-white">
      <div class="middle-main">
        <h1 class="title">{{ L('个人中心') }}</h1>
        <el-row :gutter="isPc != 3 ? 30 : 0">
          <el-col :span="isPc != 3 ? 4 : 24">
            <el-radio-group v-model="activeName" class="type-radio-group" @change="changeType">
              <el-radio-button label="1">{{ L('台商月刊') }}</el-radio-button>
              <el-radio-button label="2">{{ L('我的好书') }}</el-radio-button>
              <el-radio-button label="3">{{ L('订单记录') }}</el-radio-button>
              <!-- <el-radio-button label="4">{{ L('订单记录') }}</el-radio-button> -->
            </el-radio-group>
          </el-col>
          <el-col :span="isPc != 3 ? 20 : 24">
            <div class="right-main">
              <div class="right-main-item" v-if="activeName == '1'">
                <!-- <div class="right-main-item-title">
                  <h2>{{ L('台商月刊') }}</h2>
                </div> -->
                <div class="right-main-item-content">
                  <magazine-list class="book-lists" :magazineList="myMagazineList" />
                </div>
              </div>
              <div class="right-main-item" v-if="activeName == '2'">
                <div class="right-main-item-content">
                  <book-list class="book-lists" :magazineList="myBookList" :showPrice="false" />
                </div>
              </div>
              <div class="right-main-item" v-if="activeName == '3'">
                <div class="record">
                  <div class="record-item" v-for="item in myOrderList" :key="item.orderId + ''">
                    <div class="record-item-title">
                      <h2>{{ L('订单编号：') }}{{ item.orderNo }}</h2>
                      <div class="record-item-time flex-row justify-between">
                        <h2>{{ L('订单时间：') }}{{ item.createTime }}</h2>
                        <span>{{ item.state }}</span>
                      </div>
                    </div>
                    <div class="record-item-content">
                      <div class="record-item-content-item" v-for="item in item.itemList" :key="item.itemId">
                        <el-row>
                          <el-col :span="isPc != 3 ? 17 : 24">
                            <div class="record-item-content-item-img">
                              <img :src="item.image" alt="">
                              <h2>{{ item.title }}
                                <svg-icon icon-class="pdf2" color="#E2291E" />
                              </h2>
                            </div>
                          </el-col>
                          <el-col class="info-item" :span="isPc != 3 ? 2 : 12" style="text-align: center;">
                            <span>{{ L('電子版') }}</span>
                          </el-col>
                          <el-col class="info-item2" :span="isPc != 3 ? 4 : 9" style="text-align: center;">
                            <span class="price">HK$ <b>{{ item.payment }}</b></span>
                          </el-col>
                          <el-col class="info-item3" :span="isPc != 3 ? 1 : 3" style="text-align: center;">
                            <span>x<em> 1</em> </span>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                    <div class="record-item-total">
                      <span>{{ L('實付款：') }}</span>
                      <span class="price">HK$ <b>{{ item.payment }}</b></span>
                    </div>

                  </div>

                  <!-- <el-row :gutter="50">
                    <el-col :span="6"><span>訂購時間</span></el-col>
                    <el-col :span="8"><span>訂單編號</span></el-col>
                    <el-col :span="3"><span>購買金額</span></el-col>
                    <el-col :span="4"><span>狀態</span></el-col>
                    <el-col :span="3"><span>操作</span></el-col>
                  </el-row>
                  <el-row :gutter="50" v-for="item in myMagazineList" :key="item" :class="{ active: item == 2 }">
                    <el-col :span="6"><span>{{ item.createTime }}</span></el-col>
                    <el-col :span="8">
                      <span>
                        {{ item.orderNo }}
                      </span>
                    </el-col>
                    <el-col :span="3">
                      <span>{{ item.payment }}</span>
                    </el-col>
                    <el-col :span="4">
                      <span>{{ item.state }}</span>
                    </el-col>
                    <el-col :span="3"><span class="btn" @click="fnToOrderDetails(item.orderNo)">查看詳情</span></el-col>
                  </el-row> -->
                </div>
                <div class="justify-center" style="padding-bottom: 150px; margin-top: 70px">
                  <pagination :current-page="pageNum" :page-size="pageSize" :total="total" @changeSize="changeSize" />
                </div>
              </div>

            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ColumnTitle from "../common/column-title.vue";
import pagination from "../common/pagination.vue";
import { getUserInfo, getMyMagazineList } from "@/assets/api/login.js";
import magazineList from "../common/magazine-list.vue";
import bookList from "../common/book-list.vue";
export default {
  components: {
    ColumnTitle,
    pagination,
    magazineList,
    bookList,
  },
  computed: {
    ...mapState(['isPc'])
  },
  data() {
    return {
      activeName: "1",
      form: {
        loginName: "",
        userName: "",
      },
      password: "",
      password2: "",
      myOrderList: [],
      myMagazineList: [],
      myBookList: [],
      total: 0,
      pageNum: 1,
      pageSize: 12,
    };
  },
  created() {
    const type = this.$route.query.type;
    if (type) {
      this.activeName = type;
    }
    getUserInfo().then((res) => {
      console.log(res);
      this.form = res.data.data;
    });
    this.init();
  },
  methods: {
    changeType(e) {
      console.log(e);
      this.$router.push({
        path: `/member-center?type=${e}`,
      });
    },
    init() {
      getMyMagazineList({
        orderByColumn: "createTime",
        isAsc: "desc",
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        console.log(res);
        this.total = res.data.data.total;

        this.myOrderList = res.data.data.rows.map((item) => {
          if (item.status == 0) {
            item.state = "未付款";
          } else if (item.status == 1) {
            item.state = "取消訂單";
          } else if (item.status == 2) {
            item.state = "可觀看";
          } else if (item.status == 3) {
            item.state = "支付失敗";
          }
          item.itemList = item.itemList.map((item) => {
            item.image = item.image ? (!/^http/.test(item.image) ? this.$imgUrl + item.image : item.image) : '';
            return item;
          })
          return item;
        });
        //筛选出 status == 2 的订单
        let list = this.myOrderList.filter((item) => item.status == 2);
        //将每一个订单中的itemList的每一项拿出来放入一个一维数组中
        let arr = [];
        list.forEach((item) => {
          item.itemList.forEach((item) => {
            arr.push(item);
          })
        })
        //arr筛选出goodsTypeDict == 1的项
        this.myMagazineList = arr.filter((item) => item.goodsTypeDict == 1).map((item) => {
          item.mgzId = item.goodsId
          return item;
        });
        //arr2筛选出status == 2的项
        this.myBookList = arr.filter((item) => item.goodsTypeDict == 2).map((item) => {
          item.mgzId = item.goodsId
          return item;
        });
        console.log(this.myMagazineList);
        console.log(this.myBookList);

      });
    },
    changeSize(e) {
      console.log(e);
      this.pageNum = e;
      this.init();
    },
    fnToOrderDetails(orderNo) {
      this.$router.push({
        path: `/magazine-order-info?orderNo=${orderNo}`,
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    onSubmit() {
      console.log("submit!");
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 32px;
  color: #2C2C2E;
  line-height: 42px;
  text-align: left;
  font-style: normal;
  margin: 40px 0 30px;
}

.account {
  margin-top: 50px;
}

.record {
  .record-item {
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #E5E5EA;
    border-top-width: 8px;
    margin-bottom: 30px;

    .record-item-title {
      border-bottom: 1px solid #E5E5EA;
      padding: 20px 30px;
      display: flex;
      justify-content: space-between;

      h2 {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #2C2C2E;
        line-height: 19px;
        text-align: left;
        font-style: normal;
      }

      .record-item-time {
        span {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 14px;
          color: #2C2C2E;
          line-height: 19px;
          text-align: right;
          font-style: normal;
          margin-left: 30px;
        }
      }
    }

    .record-item-content {
      padding: 2px 30px;

      .record-item-content-item {
        .el-row {
          padding: 30px 0;
        }

        .record-item-content-item-img {
          display: flex;
          align-items: center;

          img {
            width: 100px;
            height: 134px;
            border-radius: 4px;
            object-fit: cover;
            margin-right: 20px;
          }

          h2 {
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 18px;
            color: #2C2C2E;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            display: flex;
            align-items: center;

            svg {
              width: 78px;
              height: 32px;
              background: #FFFFFF;
              border-radius: 19px;
              border: 2px solid #E2291E;
              padding: 5px 9px;
              margin-left: 12px;
            }
          }

        }

        span {
          font-family: MicrosoftYaHei;
          font-size: 14px;
          color: #2C2C2E;
          line-height: 19px;
          text-align: left;
          font-style: normal;

          em {
            font-size: 18px;
          }

          b {
            font-size: 24px;
          }
        }

        .price {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 16px;
          color: #FF3B30;
          line-height: 21px;
          text-align: left;
          font-style: normal;
        }
      }
    }

    .record-item-total {
      padding: 30px;
      display: flex;
      justify-content: flex-end;

      span {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #2C2C2E;
        line-height: 19px;
        text-align: right;
        font-style: normal;
      }

      .price {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 16px;
        color: #FF3B30;
        line-height: 21px;
        text-align: left;
        font-style: normal;

        em {
          font-size: 24px;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .member-center {
    padding: 0 20px;
  }

  .title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 24px;
    color: #2C2C2E;
    line-height: 31px;
    text-align: left;
    font-style: normal;
    margin: 30px 0 20px;
  }

  .record {
    .record-item {
      margin-bottom: 20px;

      .record-item-title {
        flex-direction: column;
        position: relative;
        padding: 16px;

        h2 {
          font-size: 12px;
          line-height: 16px;
        }

        .record-item-time {
          margin-top: 8px;
        }

        span {
          position: absolute;
          right: 16px;
          top: 16px;
        }
      }

      .record-item-content {
        padding: 2px 16px;

        .el-row {
          padding: 20px 0 !important;
        }

        .record-item-content-item {
          span {
            font-size: 12px;
            line-height: 16px;

            em {
              font-size: 14px;
            }
          }

          .price {
            font-size: 12px;
            line-height: 16px;

            b {
              font-size: 18px;
            }
          }

          .record-item-content-item-img {
            img {
              width: 80px;
              height: 107px;
              border-radius: 4px;
              margin-right: 12px;
            }

            h2 {
              font-size: 14px;
              line-height: 19px;
              position: absolute;
              top: 20px;
              left: 90px;

              svg {
                width: 50px;
                height: 20px;
                padding: 3px 7px;
              }
            }
          }

          .info-item {
            position: absolute;
            bottom: 20px;
            left: 35px;
          }

          .info-item2 {
            position: absolute;
            bottom: 20px;
            right: 30px;
          }

          .info-item3 {
            position: absolute;
            bottom: 20px;
            right: 0;
          }
        }
      }
    }
  }
}
</style>
<style>
.type-radio-group .el-radio-button {
  width: 100% !important;
}

.type-radio-group .el-radio-button__orig-radio+.el-radio-button__inner {
  width: 100% !important;
  height: 50px !important;
  background: #FFFFFF !important;
  border-radius: 25px !important;
  border: 1px solid #E5E5EA !important;
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 16px;
  color: #2C2C2E;
  line-height: 24px;
  text-align: center;
  font-style: normal;
  margin-bottom: 16px;
}

.type-radio-group .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  background: #E2291E !important;
  color: #FFFFFF !important;
  border: 1px solid #E2291E !important;
  box-shadow: none !important;
}

.member-center .el-tabs--card>.el-tabs__header {
  border-bottom: none;
}

.member-center .el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: none;
}

.member-center .el-tabs--card>.el-tabs__header .el-tabs__item {
  width: 230px;
  padding: 11px 0;
  border: solid 1px #222;
  font-family: NotoSansCJKTC;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 1.8px;
  text-align: center;
  color: #222;
  margin-right: 33px;
  height: auto;
}

.member-center .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  background-color: rgba(225, 49, 51, 0.22);
}

.el-form-item {
  display: flex;
  flex-direction: column;
}

.el-form-item__label {
  text-align: left;
  font-family: NotoSansCJKTC;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: 1.2px;
  color: #e13133;
}

.el-input__inner {
  border: none;
  border-bottom: 1px solid #e1e1e1;
  border-radius: 0;
  font-family: NotoSansCJKTC;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: 1.4px;
  text-align: left;
  color: #000;
}

.el-input__inner:focus {
  border-bottom: 1px solid #092e43;
}

.btns .el-form-item__content {
  text-align: center;
}

.btns .el-button {
  width: 299px;
  height: 50px;
  padding: 15px 119.2px 15px 119.8px;
  margin-top: 70px;
  margin-bottom: 120px;
  border-radius: 0;
  font-family: NotoSansCJKTC;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 1.4px;
  text-align: center;
}

.btns .el-button--default {
  border: solid 1px #222;

  color: #222;
}

.btns .el-button--danger {
  background-color: #e13133;
  margin-left: 28px;
  color: #fff;
}

.record .el-row {
  padding: 18px 0;
  border-bottom: 1px solid #ebebeb;
  display: flex;
  align-items: center;
}

.record .el-row span {
  font-family: NotoSansCJKTC;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.87;
  letter-spacing: 1.5px;
  text-align: right;
  color: #000;
}

.record .el-row span.btn {
  padding: 5px 15px;
  background-color: #e13133;
  font-family: NotoSansCJKTC;
  font-size: 14px;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}

.record .active span {
  color: #e13133;
}

@media screen and (max-width: 768px) {
  .el-tab-pane {
    width: 100%;
    overflow-x: scroll;
  }

  .el-tabs {
    /* margin: 0 20px; */
  }

  .member-center .el-tabs--card>.el-tabs__header .el-tabs__item {
    width: 160px;
    margin-right: 13px;
  }

  .el-form-item__label {
    text-align: left;
    font-family: NotoSansCJKTC;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: 1.2px;
    color: #e13133;
  }

  .el-input__inner {
    border: none;
    border-bottom: 1px solid #e1e1e1;
    border-radius: 0;
    font-family: NotoSansCJKTC;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.57;
    letter-spacing: 1.4px;
    text-align: left;
    color: #000;
    padding: 0;
  }

  .el-input__inner:focus {
    border-bottom: 1px solid #092e43;
  }

  .btns .el-form-item__content {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .btns .el-button {
    width: auto;
    height: 50px;
    padding: 15px 50px;
    margin-top: 30px;
    margin-bottom: 60px;
    border-radius: 0;
    font-family: NotoSansCJKTC;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: 1.4px;
    text-align: center;
  }

  .btns .el-button--default {
    border: solid 1px #222;

    color: #222;
  }

  .btns .el-button--danger {
    background-color: #e13133;
    margin-left: 15px;
    color: #fff;
  }

  .record .el-row {
    padding: 18px 0;
    border-bottom: 1px solid #ebebeb;
    display: flex;
    align-items: center;
  }

  .record .el-row span {
    font-family: NotoSansCJKTC;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.87;
    letter-spacing: 1.5px;
    text-align: right;
    color: #000;
  }

  .record .active span {
    color: #e13133;
  }
}

@media screen and (max-width: 768px) {


  .type-radio-group {
    display: flex;
    /* flex-direction: column; */
  }

  .type-radio-group .el-radio-button {
    width: fit-content !important;
    margin-right: 8px;
  }

  .type-radio-group .el-radio-button__orig-radio+.el-radio-button__inner {
    width: 104px !important;
    height: 40px !important;
    line-height: 14px !important;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #2C2C2E;
    text-align: center;
    font-style: normal;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/member-center/index.vue